// extracted by mini-css-extract-plugin
export default {"attemdence_summray_title":"style_attemdence_summray_title__DV72l","attemdence_summray_percent":"style_attemdence_summray_percent__FKxUd"};